import React from 'react'
import { Button } from '@chakra-ui/react'

export function SecondaryButton({ children, ...props }) {
    return (
        <Button bg="brand.blue" isFullWidth type="button" {...props}>{children}</Button>
    )
}